let uid = 0;

export default function (): number {
  uid++;
  return uid;
}